import React from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';
Quill.register('modules/imageResize', ImageResize);
import VideoResize from 'quill-video-resize-module2';
Quill.register('modules/VideoResize', VideoResize);
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';

import Link from '../../../Link';
import ImageUploadComponent from '../../../../components/Common/ImageUploadComponent';

import onSubmit from './submit';
import validate from './validate';
import messages from '../../../../locale/messages';
import { formatURL } from '../../../../helpers/formatUrl';
import { api, contentPageUploadDir, siteUrl } from '../../../../config';
import { updateTempImages } from '../../../../actions/siteadmin/TempImages/updateTempImages';
import { formatLocale } from '../../../../helpers/formatLocale';

import s from './AddContentPageForm.css';
import bt from '../../../../components/commonStyle.css';

import addIcon from '../../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../../public/Icons/deleteIocn.svg';

class AddContentPageForm extends React.Component {

	constructor(props) {
		super(props)
		if (typeof window !== 'undefined') this.ReactQuill = require('react-quill');
		this.state = {
			selectedLanguages: []
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicContent } = nextProps;
		let filteredLanguages = dynamicContent?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	success = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('pageBanner', fileName);
		await updateTempImages('ContentPage', 'pageBanner', fileName);
	}

	handlePageTitle = (e) => {
		const { change } = this.props;
		if (e && e.target && e.target.value) change('pageUrl', formatURL(e.target.value));
		else change('pageUrl', '');
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
		const { formatMessage } = this.props.intl;
		return (
			<FormGroup>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</FormGroup>
		)
	}

	renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div>
				<FormGroup className={s.formGroup}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} maxlength={maxlength} />
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderFormControlPageUrl = ({ input, label, placeholder, type, meta: { touched, error }, className }) => {
		const { formatMessage } = this.props.intl;
		return (
			<FormGroup className={s.formGroup}>
				<Col xs={12} sm={12} md={12} lg={12}>
					<label className={bt.labelText} >{label}</label>
				</Col>
				<Col xs={12} sm={12} md={12} lg={12}>
					<div className={'pageUrlInput'}>
						<InputGroup>
							<InputGroup.Text>
								<InputGroup.Append>
									<span>{siteUrl}</span>
								</InputGroup.Append>
							</InputGroup.Text>
							<FormControl {...input} placeholder={placeholder} type={type} className={cx(className, 'pageUrlFormInput')} />
						</InputGroup>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</Col>
			</FormGroup>
		);
	}

	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div>
				<FormGroup className={s.formGroup}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
						>
							{children}
						</FormControl>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderQuill = ({ input, meta: { touched, error }, className }) => {
		const ReactQuill = this.ReactQuill;
		const { formatMessage } = this.props.intl;
		let modules = {
			toolbar: {
				container: [
					[{ 'header': '1' }, { 'header': '2' }],
					[{ size: [] }],
					['bold', 'italic', 'underline', 'strike', 'blockquote'],
					[{ 'list': 'ordered' }, { 'list': 'bullet' },
					{ 'indent': '-1' }, { 'indent': '+1' }],
					['link', 'image', 'video']
				],
				handlers: {
					image: this.imageHandler,
				}
			},
			clipboard: {
				matchVisual: false,
			},
			imageResize: {
				parchment: Quill.import('parchment'),
				modules: ['Resize', 'DisplaySize'],
				displayStyles: {
					backgroundColor: 'black',
					border: 'none',
					color: 'white'
				},
			},
			VideoResize: {
				modules: ['Resize', 'DisplaySize'],
			}
		};

		let formats = [
			'header', 'size',
			'bold', 'italic', 'underline', 'strike', 'blockquote',
			'list', 'bullet', 'indent',
			'link', 'image', 'video', 'width', 'alt', 'height', 'style', 'size'
		];

		return (
			<div data-text-editor="name">
				<ReactQuill
					{...input}
					onChange={(newValue, delta, source) => {
						if (source === 'user' || source === 'api') input.onChange(newValue);
					}}
					onBlur={(range, source, quill) => {
						if (quill.getHTML() == '<p><br></p>') input.onBlur('');
						else input.onBlur(quill.getHTML());
					}}
					modules={modules}
					formats={formats}
					theme="snow"
					bounds={`[data-text-editor="name"]`}
				/>

				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		);
	}


	async imageHandler() {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();
		input.onchange = async () => {
			const file = input.files[0];
			const formData = new FormData();

			formData.append('image', file);

			// Save current cursor state
			const range = this.quill.getSelection(true);

			// Move cursor to right side of image (easier to continue typing)
			this.quill.setSelection(range.index + 1);

			// Get the filePath from Uploaded URL
			const res = await fetch('/file-upload-cms', {
				method: 'POST',
				body: formData
			});

			// Get Response from the String
			const data = await res.json();
			let filePath = data.filePath;

			// Remove placeholder image
			this.quill.deleteText(range.index, 1);
			filePath = "/" + filePath;

			// Insert uploaded image
			const { ops } = this.quill.insertEmbed(range.index, 'image', filePath);

		};
	}

	renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={bt.space5}>
				{label && <label className={bt.labelText} >{label}</label>}
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
		const { languageList } = this.props;
		const { formatMessage } = this.props.intl;
		const { selectedLanguages } = this.state;

		!fields.length && fields.push({})
		return (
			<div className={bt.languageBox}>
				{fields.map((item, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);

					return (
						<div key={`${index}`}>
							<Row>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.noMargin}>
									<Field name={`${item}.language`} component={this.renderFormControlSelect} label={formatMessage(messages.language)} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)}>
										<option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
										{availableLanguages?.map((locale, index) => {
											return (
												<option value={locale} key={index}>{formatLocale(locale)}</option>
											)
										})}
									</Field>
								</Col>
								<Col lg={12} md={12} sm={12} xs={12} className={bt.noMargin}>
									<FormGroup className={cx(s.formGroup, 'noMargin')}>
										<div>
											<label className={bt.labelText} ><FormattedMessage {...messages.content} /></label>
										</div>
										<div className='quillBox'>
											<Field name={`${item}.content`} component={this.renderQuill} onChange={(event) => { }} />
										</div>
									</FormGroup>
								</Col>
							</Row>
							<div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")}>
										<img src={addIcon} alt='addIcon' />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{index != 0 && <div>
									<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
										<img src={trashIcon} alt='addIcon' />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	render() {
		const { handleSubmit, pageBanner, intl: { formatMessage }, contentImageLoader } = this.props;
		const ReactQuill = this.ReactQuill;
		if (typeof window !== 'undefined' && ReactQuill) {
			return (
				<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
					<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>

						<div className={cx(s.paddingTop, s.singalCard, s.marbtm14)}>
							<FormGroup className={s.formGroup}>
								<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
									<div className={'commonFilepicker'}>
										<ImageUploadComponent
											className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
											subTextClass={cx(s.subText, 'textWhiteTwo')}
											subText={formatMessage(messages.maximumUploadSizeLabel)}
											defaultMessage={formatMessage(messages.chooseFile)}
											postUrl={api.apiEndpoint + '/uploadContentPageBannerImage'}
											handleDropzone={this.success}
											loaderName={'contentImageLoader'}
											loader={contentImageLoader}
											fieldName={'pageBanner'}
											formName={'ContentPageForm'}
											imageSrc={pageBanner ? api.apiEndpoint + contentPageUploadDir + 'large_' + pageBanner : null}
											label={<FormattedMessage {...messages.pageImageBanner} />}
											labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
										/>
									</div>
								</div>
							</FormGroup>
						</div>

						<Row>
							<Col lg={6} md={12} sm={12} xs={12}>
								<FormGroup className={s.formGroup}>
									<Field
										name="metaTitle"
										type="text"
										placeholder={formatMessage(messages.metaTitle)}
										component={this.renderFormControl}
										label={formatMessage(messages.metaTitle)}
										labelClass={bt.labelText}
										fieldClass={bt.formControlInput}
									/>
								</FormGroup>
							</Col>
							<Col lg={6} md={12} sm={12} xs={12}>
								<FormGroup className={s.formGroup}>
									<Field
										name="metaDescription"
										type="text"
										placeholder={formatMessage(messages.metaDescriptionText)}
										component={this.renderFormControlTextArea}
										label={formatMessage(messages.metaDescriptionText)}
										labelClass={bt.labelText}
										fieldClass={bt.formControlInput}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col lg={6} md={12} sm={12} xs={12}>
								<FormGroup className={s.formGroup}>
									<Field
										name="pageTitle"
										type="text"
										component={this.renderFormControl}
										label={formatMessage(messages.pageTitle)}
										placeholder={formatMessage(messages.pageTitle)}
										onChange={this.handlePageTitle}
									/>
								</FormGroup>
							</Col>
							<Col lg={6} md={12} sm={12} xs={12} className={bt.noPadding}>
								<FormGroup className={s.formGroup}>
									<Field
										name="pageUrl"
										type="text"
										component={this.renderFormControlPageUrl}
										label={formatMessage(messages.pageUrl)}
										placeholder={formatMessage(messages.pageUrl)}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col lg={12} md={12} sm={12} xs={12}>
								<FormGroup className={cx(s.formGroup, 'mb0', bt.paddingTop5, 'mt14', bt.languageBtnDivider)}>
									<FieldArray name="content" component={this.renderFieldArray} />
								</FormGroup>
							</Col>
						</Row>
						<div className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
							<Form.Group className={s.formGroup}>
								<div className='btnFlexContainer'>
									<Link to={'/siteadmin/contentpage/manage'} className={cx(bt.btnSecondary, 'backBtnRTL')} ><FormattedMessage {...messages.goBack} /></Link>
									<div className={s.displayInlineBlock}>
										<Button
											type="submit"
											className={cx(bt.btnPrimary)}
										>
											<FormattedMessage {...messages.submitButton} />
										</Button>
									</div>
								</div>
							</Form.Group>
						</div>
					</Form>
				</div>
			);
		}
		else return <span></span>;
	}
}

AddContentPageForm = reduxForm({
	form: 'ContentPageForm',
	validate,
	onSubmit,
})(AddContentPageForm);

const contentPageFormSelector = formValueSelector('ContentPageForm');
const mapState = (state) => ({
	pageTitle: contentPageFormSelector(state, 'pageTitle'),
	pageBanner: contentPageFormSelector(state, 'pageBanner'),
	contentImageLoader: state?.loader?.contentImageLoader,
	languageList: state?.runtime?.availableLocales,
	dynamicContent: contentPageFormSelector(state, 'content'),
});

const mapDispatch = {
	change,
	updateTempImages
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddContentPageForm)));